export function preloadImage (url) {
  try {
    const img = new Image()
    img.src = url
  } catch (e) {
    console.log(':(')
  }
}



// WEBPACK FOOTER //
// ./src/services/prerenderer.js